export default "__VITE_ASSET__cf60d73e__"